'use strict';

angular
  .module('amexReconciliationApp')
  .config(function ($provide) {
    $provide.decorator('$locale', function ($delegate) {
      if ($delegate.id === 'en-us') {
        $delegate.NUMBER_FORMATS.PATTERNS[1].negPre = '-\u00A4';
        $delegate.NUMBER_FORMATS.PATTERNS[1].negSuf = '';
      }
      return $delegate;
    });
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/decorators/currencyProviderDecorator.js
// module id = 508
// module chunks = 0